import { buildAnswers } from './Answers.js'

const GrammarTestReducer = (state, action) => {
  switch (action.type) {
    case 'SELECT_ANSWER':
      return {
        ...state,
        selectedAnswer: action.answer,
        checkAnswers: true,
      }
    case 'SHOW_GRAMMAR_HELP':
      return {
        ...state,
        showGrammarHelp: true,
      }
    case 'HIDE_GRAMMAR_HELP':
      return {
        ...state,
        showGrammarHelp: false,
      }
    case 'REFRESH':
      return buildAnswers(state.alreadyChosen)
    default:
      return state
  }
}

export default GrammarTestReducer
